export function cleanProtocolHtml(html: string): string {
  const temp = document.createElement('div')
  temp.innerHTML = html

  temp.querySelectorAll('*').forEach((el) => {
    el.removeAttribute('style')
    el.removeAttribute('class')
  })

  temp.querySelectorAll('*').forEach((el) => {
    if (el.children.length === 0 && !el.textContent?.trim()) {
      el.remove()
    }
  })

  return temp.innerHTML.trim()
}
